import { AfterViewInit, Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UiHelper } from '@helpers/ui.helper';
import { ApiService } from '@services/api.service';
import { DataHelper } from '@helpers/data.helper';
import { LocalizationService } from '@services/localization.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';

@Component({
  selector: 'document-info-upload',
  templateUrl: '../sharedTemplates/document-info-upload.component.html',
})
export class DocumentInfoUploadComponent implements OnInit, AfterViewInit {
  translator = new TranslatePipe(this._LocalizationService);
  title: string;
  fileName = '';
  fileNameIsActive = false;
  uploadDoc: UntypedFormGroup;
  uploadDocRaw: any;
  public input_filepath = '';
  public input_filepath_encrypted = '';
  inputIsDisabled = false;
  fileCaseControl: any;
  file;
  documentSelectComboList: { id: number; name: string; disabled?: boolean }[] = [
    {
      id: 0,
      name: this.translator.transform('Document_Upload_Select_One'),
      disabled: true,
    },
    {
      id: 1,
      name: this.translator.transform('Document_Upload_ID'),
    },
    {
      id: 2,
      name: this.translator.transform('Document_Upload_Address'),
    },
    {
      id: 4,
      name: this.translator.transform('Document_Upload_Other'),
    },
  ];
  constructor(
    private _router: Router,
    public _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _DataHelper: DataHelper,
    private _ActivatedRoute: ActivatedRoute,
    private _LocalizationService: LocalizationService,
    public _LZ: LocalizationService,
    private _FormBuilder: UntypedFormBuilder,
    private _UserHelper: UserHelper,
    private renderer2: Renderer2
  ) {
    this.uploadDoc = _FormBuilder.group({
      DocumentTypeCombo: new UntypedFormControl({ value: 0, disabled: false }, [Validators.required]),
    });
  }

  ngOnInit() {
    this.uploadDoc.valueChanges.subscribe(x => {
      this.uploadDocRaw = x;
    });
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('Personal_Documents', false);
    if (this._UiHelper.rightMenu) {
      this._UiHelper.setRightMenu();
    }

    this.caseControl();
  }

  async upload(files) {
    const fileUploadPromise = Object.keys(files).map(fileIndex => this._ApiService.UploadtoAWS(files[fileIndex], 'customer/' + this._UserHelper.customerUser.CustomerId));
    const fileUploadPromiseResult = await Promise.all(fileUploadPromise);
    fileUploadPromiseResult.forEach(x => {
      if (x.code == 'error') {
        this._UiHelper.errorSnackBar(x.message, '');
      } else if (x.code == 'success') {
        this.fileNameIsActive = true;
        // this.input_filepath = result.message;
        this.input_filepath_encrypted = x.message;
        this.AWSGetImage(x.message);
        this.inputIsDisabled = true;
      }
    });

    this.caseControl();
  }

  sendCloudFiles() {
    const translator = new TranslatePipe(this._LocalizationService);
    this._ApiService.cloudFiles(this.uploadDocRaw, this.input_filepath_encrypted).then(result => {
      const t_message = translator.transform('upload_successful', null);
      this._UiHelper.successSnackBar(t_message, '');
      this.uploadDoc.setValue({ DocumentTypeCombo: { value: '', disabled: false } });
      this.file = null;
      this.inputIsDisabled = false;
      this.caseControl();
    });
  }

  caseControl() {
    this._ApiService.getUploadFilesControl().then(x => {
      this.fileCaseControl =
        x &&
        x.map(item => {
          item.CreateDate = this.formatDate(item.CreateDate);
          // item.CreateDate = new Date(item.CreateDate.split('.')[2], item.CreateDate.split('.')[1]-1, item.CreateDate.split('.')[0]);
          return item;
        });
      //// console.log("X", x);
    });
  }

  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  AWSGetImage(imageLink) {
    this._ApiService.AWSGetImage(imageLink).then(x => {
      this.input_filepath = x.replaceAll('\\u0026', '&').replace('"', '').replace('"', '');
    });
  }
}
